import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRightOutlined } from '@ant-design/icons';

import { Typography } from 'syngenta-digital-cropwise-react-ui-kit';
import { DatePicker } from 'antd';
import { getPresetDateRanges } from '../../constants/constants';
import { useResourceMapperStore } from '../../store/useResourceMapperStore';
import { DateRange, FilterProps } from '../../types';
const { Text } = Typography;

interface UnmappedResourceDateRangeFilterProps {
  dateRangeFilter: FilterProps<DateRange>;
}

const UnmappedResourceDateRangeFilter = ({
  dateRangeFilter,
}: UnmappedResourceDateRangeFilterProps) => {
  const { t } = useTranslation();
  const { filtersState } = useResourceMapperStore();

  const handleChange = (values: any) => {
    dateRangeFilter.update({ start: values ? values[0] : null, end: values ? values[1] : null });
  };

  return (
    <>
      <div>
        <Text>{t('resource-mapper.date_range')}</Text>
      </div>
      <DatePicker.RangePicker
        data-testid="date_range_picker"
        allowEmpty={[true, true]}
        className="w-100%"
        separator={<ArrowRightOutlined />}
        placeholder={[t('resource-mapper.start_date'), t('resource-mapper.end_date')]}
        ranges={getPresetDateRanges(t)}
        defaultValue={[filtersState.dateRange.start ?? null, filtersState.dateRange.end ?? null]}
        value={[dateRangeFilter.value.start ?? null, dateRangeFilter.value.end ?? null]}
        onChange={handleChange}
        format={'DD MMM YYYY'}
      />
    </>
  );
};

export default UnmappedResourceDateRangeFilter;
